import React, { Component } from "react";
import PropTypes from "prop-types";
import ShopAllStyles from "./ShopAllStyles";

class ShopMultiple extends Component {
  constructor() {
    super();
    this.init = this.init.bind(this);
  }
  init() {
    console.log(this);
  }
  render() {
    const { view, ...otherProps } = this.props;
    switch (view) {
      case "shopAllStyles":
        return <ShopAllStyles.component {...otherProps} />;
      default:
        return <ShopAllStyles.component {...otherProps} />;
    }
  }
}
ShopMultiple.propTypes = {
  view: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ShopMultiple,
  component: ShopMultiple,
};

export { default as AddToBagActions } from "./AddToBagActions";
export { default as ShopAllStylesCarousels } from "./ShopAllStylesCarousels";
export { default as VerticalCarousel } from "./VerticalCarousel";
export { default as HorizontalCarousel } from "./HorizontalCarousel";
export { default as ProductItem } from "./ProductItem";
export { default as ShopAllStylesView } from "./ShopAllStylesView";
export { default as ShopAllStylesModal } from "./ShopAllStylesModal";
export { default as ShopAllStyles } from "./ShopAllStyles";
export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ShopMultiple/index.js